if(!customElements.get('custom-slideshow')){

    class CustomSlideshow extends HTMLElement {
        constructor(){
            super();

            this.videos = this.querySelectorAll('video');
            this.videos.forEach((video) => {
                video.addEventListener('loadeddata', function(e){
                    video.classList.add('loaded');
                })
                if (video.readyState >= 2) {
                    video.classList.add('loaded');
                }
            })

            this.swiperContainer = this.querySelector('.swiper-container');
    
            if(this.swiperContainer.querySelectorAll('.swiper-slide').length > 1 ){
                this.initSwiper();
            }
        }

        initSwiper(){
            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: true,
                spaceBetween: 0,
                centeredSlides: false,
                slidesPerView: 1,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true
            }

            if(this.swiperContainer.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                el: this.querySelector('.swiper-pagination')
                }
            }

            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev')
                }
            }

            if(this.swiperContainer.dataset.transitionEffect == 'fade'){
                swiperSettings.effect = 'fade';
                swiperSettings.fadeEffect = {
                crossFade: true
                }
            }

            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.querySelector('.swiper-container'), swiperSettings);
            this.swiper.init();
            this.swiper.on('init', this.resetVideos.bind(this));
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChangeTransitionEnd', this.resetVideos.bind(this));

            this.swiper.on("resize", () => {
                this.checkPagination();
            });

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });

            this.swiper.on('slideChangeTransitionEnd', () => {
                const currentIndex = this.swiper.activeIndex;
                const currentSlide = this.swiper.slides[currentIndex];
                
                if(currentSlide) this.swiperContainer.setAttribute('data-current-idx', currentSlide.querySelector('.slideshow__content-wrapper').dataset.idx);
            });
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        resetVideos(){
            // if videos exist and not in active slider, pause
            this.swiperContainer.querySelectorAll('.swiper-slide').forEach((item) => {
                if(item.querySelector('video')){
                    let video = item.querySelector('video');
                    if(item.classList.contains('swiper-slide-active') == false){
                        video.pause();
                        video.currentTime = 0;
                    }else{
                        if(video.classList.contains('loaded') == false){
                            video.classList.add('loaded');
                        }
                        video.play();
                    }
                }
            })
        }

        refresh(){
            this.swiperContainer = this.querySelector('.swiper-container');

            if(this.swiperContainer.querySelectorAll('.swiper-slide').length > 1 ){
                this.initSwiper();
            }
        }
    }
    customElements.define('custom-slideshow', CustomSlideshow);

}